/**
 * ThemeToggle — 2테마 토글 버튼
 * 2-state: light (02) ↔ dark (01)
 * localStorage 키: iggg-theme
 * document.documentElement dataset.theme 에 반영
 *
 * props: theme, onToggle
 */
const LABEL = { light: "LIGHT / 02", dark: "DARK / 01" };

export default function ThemeToggle({ theme, onToggle }) {
  const label = LABEL[theme] || LABEL.dark;
  return (
    <button
      onClick={onToggle}
      title={`테마: ${theme}`}
      aria-label="테마 전환"
      style={{
        fontFamily: 'var(--ff-mono, "JetBrains Mono", monospace)',
        fontSize: 11,
        fontWeight: 500,
        letterSpacing: "0.08em",
        padding: "4px 10px",
        borderRadius: "var(--radius-cap, 999px)",
        border: "1px solid var(--ds-ink)",
        background: "transparent",
        color: "var(--ds-ink)",
        cursor: "pointer",
        lineHeight: 1.4,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </button>
  );
}
